export default "__VITE_ASSET__5$b6kjOj__"